import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { IInstitutionPlan, PlanTier } from '../interfaces/plan.interface';

export const PlanService = {
    /** Any member of the institution may read its plan. */
    getPlan: async (institutionId: string): Promise<IInstitutionPlan> => {
        const response = await axios.get(ENDPOINTS.INSTITUTION.PLAN(institutionId), {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    /** SystemAdmin / SaaSOperator only. A move to FREE switches off the modules the Free plan leaves out. */
    setPlan: async (institutionId: string, planTier: PlanTier): Promise<IInstitutionPlan> => {
        const response = await axios.put(ENDPOINTS.INSTITUTION.PLAN(institutionId), { planTier }, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },
};
